import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";
import DailySignItem from "./dailysign_item";

const { ccclass, property } = cc._decorator;
@ccclass
export default class DailySignAttachItem extends DailySignItem {
    
    @property(cc.Label)
    labelTotalSignCount: cc.Label = null

    @property(cc.Label)
    labelCondition: cc.Label = null

    @property(cc.Button)
    buttonGet: cc.Button = null

    @property(cc.Node)
    nodeSelectEffect: cc.Node = null

    show(show: boolean, data?: any): boolean{
        if(super.show(show, data)){
            this.labelTotalSignCount.string = `${data.totalSignCount}`
            this.labelCondition.string = `${data.currentConditionGroup}`
            this.nodeSelectEffect.active = !data.isFinish && data.isReceive        
            this.buttonGet.interactable = !data.isFinish && data.isReceive        
            this.buttonGet.node.targetOff(this)
            this.buttonGet.node.on('click', ()=>{
                this.onClick(data)
            }, this)
            return true
        }
        
        return false
    }

    protected onClick(data){
        Utility.playButtonSound();
        EventManager.instance.dispatch('click_dailysign_attach_item', data)
    }

}